import { HeadObjectCommand, ListObjectsV2Command, S3Client } from '@aws-sdk/client-s3';

export class ClientTimeTooSkewedError extends Error {
  constructor(message?: string) {
    super(message || 'クライアントの時刻がずれています');
    this.name = 'ClientTimeTooSkewedError';
    Object.setPrototypeOf(this, ClientTimeTooSkewedError.prototype);
  }
}

export async function checkClientTimeSkewed(s3Client: S3Client, bucket: string, key: string) {
  const headObjectPromise = s3Client.send(new HeadObjectCommand({
    Bucket: bucket,
    Key: key
  }))

  const listObjectsPromise = s3Client.send(new ListObjectsV2Command({
    Bucket: bucket,
    Prefix: key,
    MaxKeys: 1
  }))

  const results = await Promise.allSettled([headObjectPromise, listObjectsPromise])

  // RequestTimeTooSkewed があるかチェック
  const errors = results
    .filter((result): result is PromiseRejectedResult => result.status === 'rejected')
    .map(result => result.reason)

  const hasTimeSkewedError = errors.some((err: any) => err.name === "RequestTimeTooSkewed")
  if (hasTimeSkewedError) {
    throw new ClientTimeTooSkewedError()
  }

  // 時刻エラーがない場合、どちらかが成功していればOK
  const hasSuccess = results.some(result => result.status === 'fulfilled')
  if (hasSuccess) {
    return
  }

  // その他のエラーは無視（時刻チェックできないが処理続行）
}
